import Swal from "sweetalert2"

const Toast = (message="",type='success')=>{
    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        background: type === "success" ?'#1b5df3' : "#ff0000",
        color: '#fff',
        customClass: {
            popup: 'custom-swal-dimensions',
            icon: 'swal2-icon-show'
        },
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
    if(type==='success'){
        Toast.fire({
            icon: 'success',
            title: message
        })
    }else if(type==='error'){
            Toast.fire({
                icon: 'error',
                title: message
            })
    }
    

}

export default Toast;